<template>
  <div>
    <!-- <EngagedDriversByZone
      v-if="!loading"
      :data="data"
    /> -->
    <base-overlay :show="loading">
      <b-card v-if="loading" />
      <b-card
        v-else
        @click="displayModalTable"
      >
        <div class="d-flex justify-content-between align-items-center">
          <h3 class="text-primary mb-0">
            Engaged Drivers
          </h3>
          <b-button
            variant="flat-primary"
            class="btn-icon rounded-circle"
            @click.prevent="fetch"
          >
            <feather-icon
              icon="RefreshCwIcon"
            />
          </b-button>
        </div>
        <b-table
          :fields="tableColumns"
          :items="data"
          hover
          striped
          responsive
          class="text-center"
        />
        <!-- <h4 class="text-center mt-2">
          {{ data.aggregations.count.value }}
        </h4> -->
      </b-card>
    </base-overlay>
  </div>
</template>

<script>
import {
  BCard, BButton, BTable,
} from 'bootstrap-vue'
import { ref } from '@vue/composition-api'
// import EngagedDriversByZone from './EngagedDriversByZone.vue'

export default {
  components: {
    BCard, BButton, BTable,
    //  EngagedDriversByZone,
  },
  props: {
    serviceType: {
      type: String,
      default: undefined,
    },
  },
  setup(props, ctx) {
    const tableColumns = [
      'today',
      'yesterday',
      {
        label: 'yesterday (*)',
        key: 'yesterdayTillNow',
      },
      'lastweek',
      {
        label: 'lastweek (*)',
        key: 'lastweekTillNow',
      },

    ]
    const data = ref([])
    const loading = ref(false)
    const fetch = async () => {
      data.value = []
      loading.value = true
      const res = await ctx.root.$store.dispatch('trips/fetchDriverAggsByCompletedTrips', {
        serviceType: props.serviceType,
      })
      const temp = {}
      Object.entries(res).forEach(([key, val]) => {
        temp[key] = val.aggregations.count.value
      })
      data.value.push(temp)
      loading.value = false
    }
    const displayModalTable = () => {
      // ctx.root.$bvModal.show('drivers-aggs-completed-modal')
    }
    fetch()
    return {
      tableColumns,
      loading,
      fetch,
      data,
      displayModalTable,
    }
  },
}
</script>

<style>

</style>
